import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import AccountTypeChooser from "@/components/app/AccountTypeChooser";
import { useAuth } from "@/context/AuthContext";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function Login() {
  const { setUser } = useAuth();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const [kind, setKind] = useState(params.get("tipo") === "adega" ? "adega" : "curtir");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      if (data.token) localStorage.setItem("encosta_token", data.token);
      setUser(data.user);
      toast.success("Bem-vindo de volta!");
      nav(kind === "adega" ? "/adega" : "/");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  const googleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    if (kind === "adega") localStorage.setItem("encosta_next", "/adega");
    const redirectUrl = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen flex flex-col px-6 py-10 max-w-md mx-auto">
      <div className="mt-4 mb-8">
        <div className="text-5xl heading font-extrabold tracking-tight">Enkosta<span className="text-primary">.</span></div>
        <p className="text-muted-foreground mt-2">Os rolês de Marília no seu bolso.</p>
      </div>

      <AccountTypeChooser value={kind} onChange={setKind} />

      <form onSubmit={submit} className="space-y-4" data-testid="login-form">
        <div className="space-y-2">
          <Label htmlFor="email">E-mail</Label>
          <Input id="email" type="email" value={email} onChange={(e)=>setEmail(e.target.value)} required data-testid="login-email-input" placeholder="voce@email.com" />
        </div>
        <div className="space-y-2">
          <Label htmlFor="password">Senha</Label>
          <Input id="password" type="password" value={password} onChange={(e)=>setPassword(e.target.value)} required data-testid="login-password-input" placeholder="••••••••" />
        </div>
        <Button type="submit" disabled={loading} className="w-full h-12 text-base press" data-testid="login-submit-button">
          {loading ? "Entrando..." : "Entrar"}
        </Button>
      </form>

      <div className="flex items-center gap-3 my-6 text-muted-foreground text-sm">
        <div className="h-px bg-border flex-1" /> ou <div className="h-px bg-border flex-1" />
      </div>

      <Button variant="outline" className="w-full h-12 press" onClick={googleLogin} data-testid="google-login-button">
        Continuar com Google
      </Button>

      <p className="text-sm text-muted-foreground mt-8 text-center">
        Novo por aqui?{" "}
        <Link to={kind === "adega" ? "/register?tipo=adega" : "/register"} className="text-primary font-medium" data-testid="go-to-register-link">Criar conta</Link>
      </p>

      <p className="text-xs text-muted-foreground mt-6 text-center">
        <Link to="/termos" className="underline">Termos</Link> · <Link to="/privacidade" className="underline">Privacidade</Link>
      </p>
    </div>
  );
}
